import {
    DELETE_COURSE_ERROR,
    DELETE_COURSE_SUCCESS
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case DELETE_COURSE_SUCCESS:
          return {
            ...state,
            deletedCourseData: action.payload,
          };
        case DELETE_COURSE_ERROR:
          return {
            ...state,
            deletedCourseError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    